import { Alert } from "@common/Alert";
import { ComponentColor } from "@common/types";
import {
    CLIENT_CLOSED_MESSAGE,
    MAY_BE_ADDED_MESSAGE,
    describeAddedLocation,
    type AddLocationOutcomeState,
} from "../_helpers/addLocation";

interface AddLocationOutcomeProps {
    outcome: AddLocationOutcomeState;
}

// What the last New Location add did, above the client's location list (the
// new row may not be there: the re-read can fail). Only an approval reads as
// a success; everything else is an alert.
export const AddLocationOutcome = ({ outcome }: AddLocationOutcomeProps) => {
    if (outcome.kind === "client_closed") {
        return <Alert color={ComponentColor.Error}>{CLIENT_CLOSED_MESSAGE}</Alert>;
    }

    if (outcome.kind === "unknown") {
        return <Alert color={ComponentColor.Error}>{MAY_BE_ADDED_MESSAGE}</Alert>;
    }

    const view = describeAddedLocation(outcome.result);

    if (view.color === ComponentColor.Success) {
        return (
            <p role="status" className="font-medium">
                {view.title} {view.detail}
            </p>
        );
    }

    return (
        <Alert color={view.color} title={view.title}>
            {view.detail}
        </Alert>
    );
};
